import { Pressable, View } from 'react-native';
import { Text } from '@/components/ui/text';
import { Icon } from '~/global/components/icon/Icon';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { UnitChip } from './UnitChip';

export interface UnitDropdownOption {
  id: string;
  label: string;
}

export interface UnitDropdownProps {
  options: UnitDropdownOption[];
  selectedId: string;
  onSelect: (id: string) => void;
  testID?: string;
}

/**
 * Serving-unit selector for web + Android. Renders the {@link UnitChip} trigger and a
 * popover dropdown listing every unit, with a check on the selected one. iOS uses the
 * native menu variant in `UnitDropdown.ios.tsx`.
 */
export const UnitDropdown = ({
  options,
  selectedId,
  onSelect,
  testID,
}: UnitDropdownProps) => {
  const selected = options.find((o) => o.id === selectedId) ?? options[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Pressable className="active:opacity-70">
          <UnitChip testID={testID} label={selected?.label ?? ''} />
        </Pressable>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        {options.map((option) => (
          <DropdownMenuItem key={option.id} onPress={() => onSelect(option.id)}>
            {option.id === selectedId ? (
              <Icon name="Check" size={14} className="text-text-primary" />
            ) : (
              <View className="w-[14px]" />
            )}
            <Text>{option.label}</Text>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
